import {SagaIterator} from 'redux-saga';
import {select} from 'typed-redux-saga';

import {State} from 'app/setup';

/**
 * Loads the current criteria-list version string.
 *
 * @param id Criteria list id.
 * @returns The current list version.
 */
export function* getCriteriaListVersion(id: number): SagaIterator<string> {
    const criteriaLists = yield* select((state: State) => state.mating.criteriaLists);
    const criteriaList = criteriaLists
        .findIn(y => y.id === id)
        .orCrash('criteriaLists not available');

    return criteriaList.version;
}
